import { takeEvery } from 'redux-saga/effects';
import {
  DELETE_FILE,
  LOAD_FILE_BY_URL,
  SET_LOCALE,
  UPLOAD_FILE,
} from '../actions';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';

import setLocale from './setLocale';
import uploadFile from './uploadFile';
import loadFileByUrl from './loadFileByUrl';
import deleteFile from './deleteFile';

export default function* watchSystem() {
  yield takeEvery(SYSTEM_MODULE + SET_LOCALE, setLocale);
  yield takeEvery(SYSTEM_MODULE + UPLOAD_FILE, uploadFile);
  yield takeEvery(SYSTEM_MODULE + DELETE_FILE, deleteFile);
  yield takeEvery(SYSTEM_MODULE + LOAD_FILE_BY_URL, loadFileByUrl);
}
